module.exports = __webpack_public_path__ + "media/images/flags/4x3/nru-e40b9e0c184eecad11844462621f4331.svg";